import createRoute from '@widesk-ui/tools/createRoute';
import MenuModel   from '@models/shop/MenuModel';

export default createRoute.dashboard('/menu', 'shop', 'MenuDashboard', MenuModel.localize());
